import axios from "axios";

/**
 * Api calls
 * 
 * With this class we can make call to django backend by simply initializing
 * class object where ever it's needed to getther data from backend.
 * 
 * How to use: API = new Api(); API.getHouseInfo(qr) 
 * 
 * @param None
 * @returns {JSON}: Returns json object which is easy to interact through js code.
 * 
 * @todo: 
 *          1. api_url value should be hidden.
 *          2. Implement login logic.
 */
export default class Api {

    // Conststructs url path and set client object to null.
    constructor() {
        this.api_url = process.env.REACT_APP_API_URL;
        this.client = null;
    }

    // Init method will happens on every call.
    init = () => {
        let headers = { // Headers for communication
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };

        // Initialization of client.
        this.client = axios.create({
            baseURL: this.api_url,
            timeout: 31000,
            headers: headers,
        });
        return this.client
    }

    /**
     * Customer registration
     */

    // Backed Path /qr_backend/contact/bigcompany/ - path to create new ticket for taking contact
    register_bigcompany_contact = (data) => {
        return this.init().post('/qr_backend/contact/bigcompany/', data);
    }

    register_missing_document = (data) => {
        return this.init().post('/qr_backend/register/missing/document/', data);
    }

    register_missing_document_get_user = (token) => {
        return this.init().get(`/qr_backend/register/missing/document/${token}/`);
    }

    // Backend Path: /qr/register - path to register client
    register_basic = (data) => {
        return this.init().post('/qr_backend/register/basic', data);
    }
    // Backend Path /qr_backend/register/exists/:email/ - check if user exists with email
    email_exists = async(email) => {
        return this.init().get(`/qr_backend/register/exists/${email}/`);
    }
    // Backend Path /qr_backend/register/mail/check/:token/ - verify email
    mail_verify = (token) => {
        return this.init().get(`/qr_backend/register/mail/verify/${token}`);
    }
    // Backend Path /qr_backend/register
    register_complete = (data) => {
        return this.init().post('/qr_backend/register', data);
    }
    // Backend Path /qr_backend/register/verified/:user_id/ - mail is verified
    mail_verified = (email) => {
        return this.init().get(`qr_backend/register/mail/verified/${email}`);
    }
    get_document_text = (key) => {
        return this.init().get(`qr_backend/document/${key}/`);
    }
    missing_document_unsubscribe = (token) => {
        return this.init().get(`/qr_backend/missing/document/unsubscribe/${token}/`)
    }


    /**
     * Models get
     */

    // Backend Path /qr/:qr - path to check if qr code is valid
    top_get_by_qr= (qr) => {
        return this.init().get(`/qr_backend/top/qr/${qr}`);
    }
    // Backend Path /qr_backend/partner/email/:email - get partner by using email
    partner_get_by_email = (email) => {
        return this.init().get(`/qr_backend/partner/email/${email}`);
    }
    // Backend Path /qr_backend/partner/image/:id/
    partner_get_image = (id) => {
        return this.init().get(`/qr_backend/partner/image/${id}`);
    }
    // Backend path /qr_beckend/anlagen/:qr_code/ - get anlagen from qr code
    anlagen_get_by_qr = (qr) => {
        return this.init().get(`/qr_beckend/anlagen/qr/${qr}/`);
    }
    // Backend path /qr_backend/qr/info/:qr_code/ - get all starting infos 
    qr_info = (qr) => {
        return this.init().get(`/qr_backend/qr/info/${qr}/`);
    }



    /**
     * Customer login
     */

    // Backend Path: /login  - path for loggin in client.
    login = (email, password) => {
        let data = {"email": email, "password": password}
        return this.init().post('/qr_backend/login', data);
    }

    refreshAccessToken = () => {
        console.error("INSIDE");
        let token = JSON.parse(localStorage.getItem('token'));
        this.init().post('/qr_backend/login/refresh', token.refresh)
            .then((res) => {
                let data = res.data;
                return data;
            })
    }


    /**
     * Customer password change
     */

    // Backend path qr_backend/password/token/alive - checks if the password token is still alive
    password_token_alive = (token) => {
        return this.init().get(`/qr_backend/passwort/token/alive/${token}/`);
    }
    // Backend path qr_backend/password/email/:email - checks mail and if exists sends email reset link to customer
    password_send_mail = (email) => {
        return this.init().get(`/qr_backend/password/email/${email}`);
    }
    // Backend path qr_backend/password/change - sends put data to backend to change password in odoo
    password_change = async(data) => {
        return await this.init().put('/qr_backend/password/change', data);
    }


    /**
     * Access request
     */
    access_request = (data) => {
        return this.init().post('/qr_backend/access/request/', data);
    }

}